module.exports = __webpack_public_path__ + "static/media/ing.e4962658.jpg";